export default __webpack_public_path__ + "static/media/supplier.01ea8f08.svg";